/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import classnames from 'classnames';
import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import { IMoeAudioPlayerData } from './moe-audio-player.data';
import { IMoeAudioPlayerProps } from './moe-audio-player.props.autogenerated';

export interface IMoeAudioPlayerViewProps extends IMoeAudioPlayerProps<IMoeAudioPlayerData> {
    AudioPlayerTag: IModuleProps;
    AudioPlayerContainer: INodeProps;
}

/**
 *
 * MoeAudioPlayer component
 * @extends {React.PureComponent<IMoeAudioPlayerProps<IMoeAudioPlayerData>>}
 */
class MoeAudioPlayer extends React.PureComponent<IMoeAudioPlayerProps<IMoeAudioPlayerData>> {
    public render(): JSX.Element | null {
        const viewProps: IMoeAudioPlayerViewProps = {
            ...this.props,
            AudioPlayerTag: {
                moduleProps: this.props,
                className: classnames('ms-moe-audio-player')
            },
            AudioPlayerContainer: {
                className: classnames('ms-moe-audio-player__container')
            }
        };

        return this.props.renderView(viewProps);
    }
}

export default MoeAudioPlayer;
